import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Avatar,
} from "@mui/material";
import MailIcon from "@mui/icons-material/Mail";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Button from "../button/Button";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import { useDispatch } from "react-redux";
import { sendEmail } from "../../../screens/patient-screen/patientSaga";

const SendEmailDialog = ({ open, onClose, contact }: any) => {
  const dispatch = useDispatch();
  const email =
    contact?.find((c: any) => c.label.toLowerCase().includes("email"))?.value ||
    "";
  const name =
    contact?.find((c: any) => c.label.toLowerCase().includes("name"))?.value ||
    "";

  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");

  // More robust check that strips HTML tags from description
  const stripHtml = (html: string) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const isDisabled =
    subject.trim().length === 0 || stripHtml(description).trim().length === 0;

  // Quill editor configuration
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      ["link"],
      ["clean"],
    ],
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "color",
    "background",
  ];

  const handleSend = () => {
    // Implement your send email logic here
    // description will contain HTML content

    const data = {
      apiPayload: {
        to: email,
        subject: subject,
        text: description,
      },
      onClose,
    };
    dispatch(sendEmail(data));
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose("close");
        }
      }}
      disableEscapeKeyDown
      PaperProps={{
        style: {
          height: "80vh", // Set dialog height to 80% of viewport height
          maxHeight: "600px", // Maximum height limit
          overflowX: "hidden",
        },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Avatar sx={{ bgcolor: "#1976d2" }}>
            <MailIcon />
          </Avatar>
          <span>Send Email</span>
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" gutterBottom>
          To: <b>{name}</b> ({email})
        </Typography>
        <TextField
          label="Subject"
          fullWidth
          margin="normal"
          size="small"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />

        <Typography
          variant="subtitle2"
          style={{ marginTop: 16, marginBottom: 8 }}
        >
          Description:
        </Typography>
        <div style={{ marginBottom: 16 }}>
          <ReactQuill
            theme="snow"
            value={description}
            onChange={setDescription}
            modules={quillModules}
            formats={quillFormats}
            style={{ height: 200 }}
          />
        </div>
      </DialogContent>
      <DialogActions style={{ padding: "16px 24px" }}>
        {/* <Button onClick={onClose} variant="outlined" color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSend} variant="contained" color="primary">
          Send
        </Button> */}

        <Button
          label={TEXT_CONSTANTS?.CANCEL}
          variant="outlined"
          onClickCb={onClose}
          style={{
            width: "120px",
            height: "44px",
            padding: "12px 20px",
            fontSize: "16px",
            backgroundColor: "white",
            border: "none",
            color: "#393939",
          }}
        />
        <Button
          type="submit"
          label={"Send"}
          variant="contained"
          onClickCb={handleSend}
          disabled={isDisabled}
          style={{
            padding: "8px 35px",
            fontSize: "16px",
          }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default SendEmailDialog;
